<template>
  <div :id="`${def.name}-abr-grid`">
    <div
      v-if="
        (def.gridActions &&
          def.gridActions.find((action) => action.name === 'gcaExportXLS')) ||
        (def.cmnActions && def.cmnActions.gcaExportXLS)
      "
    >
      <button @click="exportData">
        <v-icon>mdi-google-spreadsheet</v-icon>
      </button>
    </div>
    <AbrGraph
      v-if="
        def.gridDisplay &&
        def.gridDisplay.name === 'ECore.Def.DefEnums.DispGraph'
      "
      :def="def"
      :model="model"
    />
    <div v-else>
      <div
        v-if="
          def &&
          def.panel &&
          !def.searchProps &&
          !def.searchConfig &&
          model &&
          (model.length === 0 || model.filter((m) => !m.Deleted).length === 0)
        "
        class="d-flex flex-column"
      >
        <AppPortal :to="`${getPortalId()}.rightSection`">
          <span v-if="EmptyModalMessage"
            ><v-icon color="blue"> mdi-information </v-icon>
            {{ EmptyModalMessage }}</span
          >
          <span v-else> {{ $t("ECore.Cmn.FixedMsg.EmptyGrid") }}</span>
        </AppPortal>
        <div class="d-flex justify-center">
          <AppPortal v-if="getPortalId()" :to="`${getPortalId()}.leftSection`">
            <span
              v-for="action in def.gridActions"
              :key="action.id"
              class="payorder-action-wrapper"
              @click.capture="interceptCreateClick($event, action)"
            >
              <AppButton
                plain
              :def="{ grid: def, ...action }"
              :model="model"
              class="mt-2"
              @onSubmit="pushToModel"
            ></AppButton>
            </span>
          </AppPortal>
          <div v-else>
            <span
              v-for="action in def.gridActions"
              :key="action.id"
              class="payorder-action-wrapper"
              @click.capture="interceptCreateClick($event, action)"
            >
              <AppButton
                outlined
              :def="{ grid: def, ...action }"
              :model="model"
              class="mt-2"
              @onSubmit="pushToModel"
            ></AppButton>
            </span>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="def.searchConfig" class="search-grid">
          <AbrBasicSearch
            v-if="def.searchConfig.basicSearch"
            :def="{
              searchConfig: { searchPage: def, ...def.searchConfig },
              ...def.searchConfig.basicSearch,
            }"
            :model.sync="searchModel"
            width="50%"
          />
          <AppDialog
            v-if="searchModel.openAS"
            v-model="searchModel.openAS"
            width="60vw"
          >
            <AbrAdvancedSearch
              v-if="def.searchConfig.advancedSearch"
              :def="{
                searchConfig: { searchPage: def, ...def.searchConfig },
                ...def.searchConfig.advancedSearch,
                search,
              }"
              :model.sync="searchModel"
            ></AbrAdvancedSearch>
          </AppDialog>
        </div>
        <v-data-table
          :id="`search_grid_${def.id}`"
          v-model="localSelected"
          :sort-by="def.sortBy && def.sortBy"
          :fixed-header="getModel.length > 10"
          :height="getModel.length > 10 ? tableHeight : undefined"
          class="grid_table"
          :items="getModel"
          :headers="[
            ...headers.filter((h) => visibleCol(h)),
            { text: '', value: 'data-table-expand' },
          ]"
          v-bind="$attrs"
          flat
          item-key="clientID"
          :show-select="
            def.select &&
            (def.select.name === 'ECore.Def.DefEnums.sMulti' ||
              def.select.name === 'ECore.Def.DefEnums.sSingle')
          "
          :show-expand="def.showExpand"
          single-expand
          :page.sync="currentPage"
          :hide-default-footer="true"
          :items-per-page="isPayorderCrSelectForm ? 100 : -1"
          :footer-props="isPayorderCrSelectForm
            ? {
                'items-per-page-options': [100],
                'show-current-page': true,
                'show-first-last-page': true,
              }
            : { 'items-per-page-options': [-1] }"
          v-on="$listeners"
          @toggle-select-all="handleSelectAll"
        >
          <!-- صفحه‌بندی اختصاصی تنها برای فرم انتخاب اعتبار؛ سایر فرم‌ها بدون تغییر -->
          <template v-if="isPayorderCrSelectForm" #footer>
            <div class="payorder-pagination" dir="rtl">
              <div class="payorder-page-info">
                <v-icon small color="primary">mdi-format-list-numbered-rtl</v-icon>
                <span>
                  نمایش <strong>{{ pageStart }}</strong> تا
                  <strong>{{ pageEnd }}</strong> از
                  <strong>{{ getModel.length.toLocaleString('fa-IR') }}</strong> رکورد
                </span>
                <span class="payorder-page-selection">
                  {{ localSelected.length.toLocaleString('fa-IR') }} انتخاب‌شده
                </span>
              </div>
              <div class="payorder-page-controls">
                <span class="payorder-page-caption">
                  صفحه {{ currentPage.toLocaleString('fa-IR') }} از {{ totalPages.toLocaleString('fa-IR') }}
                </span>
                <v-pagination
                  v-model="currentPage"
                  :length="totalPages"
                  :total-visible="7"
                  circle
                  color="primary"
                  prev-icon="mdi-chevron-left"
                  next-icon="mdi-chevron-right"
                  class="payorder-page-buttons"
                />
              </div>
            </div>
          </template>
          <template #expanded-item="{ item }">
            <td
              style="border-bottom: #d7d7d7 solid 0.5px !important"
              :colspan="headers.length"
              class="pa-0"
            >
              <div :key="item.clientID" class="expanded--panel BG2">
                <v-row>
                  <v-col
                    v-for="(h, index) in headers.filter((hh) => !hh.show)"
                    :key="index"
                    cols="3"
                  >
                    <div class="G2--text">{{ h.text }} :</div>
                    <v-row>
                      <v-col :cols="h.suffixLabel ? 9 : 12">
                        <div style="margin-top: 7px">
                          <AbrFormPropLookUp
                            v-if="h.def.lookup"
                            :key="h.def.name"
                            :def="h.def"
                            :model="item"
                            ingrid="true"
                            readonly="true"
                          >
                          </AbrFormPropLookUp>
                          <div
                            v-else
                            :class="h.def.cssClass ? h.def.cssClass : ''"
                          >
                            {{ displayValue(h.def, item[h.value]) }}
                          </div>
                        </div>
                      </v-col>
                      <v-col
                        v-if="h.suffixLabel"
                        cols="3"
                        class="grid_suffix_label"
                      >
                        {{ h.suffixLabel }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
          <template #top>
            <div class="d-flex align-center justify-space-between">
              <div v-if="def.gridActions">
                <AppPortal v-if="getPortalId()" :to="checkPageType()">
                  <span
              v-for="action in def.gridActions"
              :key="action.id"
              class="payorder-action-wrapper"
              @click.capture="interceptCreateClick($event, action)"
            >
              <AppButton
                plain
                    :def="{ grid: def, ...action }"
                    :model="model"
                    class="mt-2"
                    @onSubmit="pushToModel"
                  ></AppButton>

                  </span>
                </AppPortal>
                <div v-else>
                  <span
              v-for="action in def.gridActions"
              :key="action.id"
              class="payorder-action-wrapper"
              @click.capture="interceptCreateClick($event, action)"
            >
              <AppButton
                outlined
                    :def="{ grid: def, ...action }"
                    :model="model"
                    class="mt-2"
                    @onSubmit="pushToModel"
                  ></AppButton>

                  </span>
                </div>
              </div>
            </div>
            <div v-if="def.searchProps">
              <v-row>
                <AbrFormProp
                  v-for="sp in def.searchProps"
                  :key="sp.id"
                  :def="sp"
                  :model="model"
                  auto-grow
                  filled
                ></AbrFormProp>
              </v-row>
            </div>
          </template>
          <template #item.number="{ item }">
            {{
              searchModel.result.filter((item) => !item.Deleted).indexOf(item) +
                1 || model.filter((item) => !item.Deleted).indexOf(item) + 1
            }}
          </template>
          <template
            v-for="prop of def.properties &&
            def.properties.map((p) => ({ slot: 'item.' + p.name, def: p }))"
            #[prop.slot]="{ item, index }"
          >
            <template
              v-if="
                isDefaultField &&
                prop.def.name === isDefaultField.name &&
                $formMode !== 'fmView'
              "
            >
              <v-radio-group :key="prop.id" v-model="item[isDefaultField.name]">
                <v-radio
                  :value="$lookupValue(isDefaultField.lookup, true)"
                  @change="setDefault(item, index)"
                ></v-radio>
              </v-radio-group>
            </template>
            <template v-else-if="prop.def.lookup">
              <AbrFormPropLookUp
                :key="prop.def.name"
                :def="prop.def"
                :model="item"
                ingrid="true"
                readonly="true"
              >
              </AbrFormPropLookUp>
              <!--          {{cells[prop.def.name] && (Array.isArray(item[prop.def.name]) && cells[prop.def.name].filter(c => item[prop.def.name].includes(c.ID)).map(c => c.DisplayText).join(" , ") || (cells[prop.def.name].find(c => c.ID === item[prop.def.name]) || {}).DisplayText)}}-->
            </template>
            <template v-else>
              <div
                :id="`${prop.def.id}-abr-grid-cell`"
                :key="prop.id"
                :class="[
                  'grid-cell-content',
                  prop.def.cssClass ? prop.def.cssClass : '',
                ]"
              >
                {{ displayValue(prop.def, item[prop.def.name]) }}
              </div>
            </template>
          </template>
          <template #item.actions="{ item, index }">
            <div class="actions d-flex">
              <AppButton
                v-for="action in def.rowActions"
                :key="action.id + index"
                :def="action"
                :model="
                  Object.assign(item, { delete: () => remove(item, index) })
                "
                text
                rounded
                small
                :class="[
                  'rowAction',
                  {
                    'always-visible': action.cssClass === 'ClickRowAction',
                  },
                ]"
                :title="$t(action)"
              >
              </AppButton>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- تایید ثبت فقط برای فرم انتخاب اعتبار؛ قبل از اجرای AppButton -->
    <v-dialog
      v-if="isPayorderCrSelectForm"
      v-model="createConfirmOpen"
      max-width="460"
      persistent
    >
      <v-card dir="rtl" class="payorder-confirm-card">
        <v-card-title class="payorder-confirm-title">
          <v-icon color="warning" class="ml-2">mdi-alert-outline</v-icon>
          تأیید افزودن اعتبارها
        </v-card-title>
        <v-card-text class="payorder-confirm-text">
          شما در حال افزودن
          <strong>{{ selectedCount.toLocaleString('fa-IR') }}</strong>
          اعتبار به دستور پرداخت هستید.
          <div class="mt-2">
            این عملیات تمام رکوردهای انتخاب‌شده از همه صفحات را شامل می‌شود.
          </div>
        </v-card-text>
        <v-card-actions class="justify-end pa-4">
          <v-btn text @click="cancelCreateConfirmation">انصراف</v-btn>
          <v-btn color="primary" @click="confirmCreateAction">
            تأیید و افزودن {{ selectedCount.toLocaleString('fa-IR') }} اعتبار
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AppButton from "@/components/library/action/AppButton";
import AbrFormPropLookUp from "@/components/form/AbrFormPropLookUp";
import AbrFormProp from "@/components/form/AbrFormProp";
import AbrGraph from "@/components/library/grids/AbrGraph";
import AbrPropDisplayValue from "../../../mixins/AbrPropDisplayValue";
import AppPortal from "@/components/library/portal/AppPortal";
import AbrBasicSearch from "../../search/AbrBasicSearch.vue";
import AbrAdvancedSearch from "@/components/search/AbrAdvancedSearch";
import AppDialog from "../container/AppDialog.vue";
import { excelParser } from "./excelParser";
import AbrEventsOff from "@/mixins/AbrEventsOff";

export default {
  name: "AbrGrid",
  components: {
    AppButton,
    AbrFormPropLookUp,
    AbrFormProp,
    AbrGraph,
    AppPortal,
    AbrBasicSearch,
    AbrAdvancedSearch,
    AppDialog,
  },
  mixins: [AbrPropDisplayValue, AbrEventsOff],
  props: {
    def: { type: Object, required: true },
    model: { type: Array, required: true },
    selected: { type: Array, default: () => [] }, // Add selected prop
  },
  data() {
    return {
      singleSelect: false,
      headers: [],
      cells: {},
      basicSearch: {},
      isDefaultField: null,
      localSelected: this.selected,
      search: {},
      abrSelected: [],
      Model: this.model,
      EmptyModalMessage: undefined,
      searchModel: {
        basicSearch: {
          query: {},
        },
        advancedSearch: {
          query: null,
          orderBy: [{ id: Symbol() }],
        },
        showGrid: false,
        loading: false,
        openAS: false,
        result: [],
        folderId: null,
      },
      listData: [],
      // Select All مستقل از صفحه جاری است؛ داده‌ها همچنان صفحه‌بندی می‌شوند.
      selectAllRecords: false,
      // شماره صفحه تنها در جدول فرم اعتبار استفاده می‌شود.
      currentPage: 1,
      // کنترل تأیید قبل از کلیک واقعی روی اکشن ایجاد
      createConfirmOpen: false,
      pendingCreateButton: null,
      allowConfirmedClick: false,
    };
  },
  computed: {
    selectedCount() {
      return Array.isArray(this.localSelected) ? this.localSelected.length : 0;
    },
    // تشخیص فرم از زنجیره والدها: def این کامپوننت معمولاً مربوط به Grid است، نه Form.
    isPayorderCrSelectForm() {
      const targetName = "frmSearchPayorderCrSelect";
      let vm = this;
      while (vm) {
        const definition = vm.def;
        if (
          definition?.name === targetName ||
          definition?.origin?.name === targetName ||
          definition?.form?.name === targetName ||
          definition?.form?.origin?.name === targetName
        ) {
          return true;
        }
        vm = vm.$parent;
      }
      return false;
    },
    // محاسبات نمایش بازه صفحه فقط روی داده‌های بارگذاری‌شده انجام می‌شود.
    totalPages() {
      return Math.max(1, Math.ceil(this.getModel.length / 100));
    },
    pageStart() {
      if (!this.getModel.length) return 0;
      return ((this.currentPage - 1) * 100 + 1).toLocaleString('fa-IR');
    },
    pageEnd() {
      return Math.min(this.currentPage * 100, this.getModel.length).toLocaleString('fa-IR');
    },
    getModel() {
      const res = this.Model?.filter((item) => !item.Deleted) || [];
      return res;
    },
    hasOnModelChangedEvent() {
      return this.def.eventHandlers && Array.isArray(this.def.eventHandlers)
        ? !!this.def.eventHandlers.find(
            (e) => e.customEventName === "onModelChanged",
          )
        : false;
    },
    computedItemsPerPage() {
      return this.def.defaultNumRows === undefined
        ? -1
        : this.def.defaultNumRows;
    },
    tableHeight() {
      const rowHeight = 56;
      const headerHeight = 58;

      const rows = this.getModel.length;

      if (rows <= 10) {
        return headerHeight + rows * rowHeight;
      }
      return headerHeight + 10 * rowHeight;
    },
  },
  watch: {
    // اگر نتایج جست‌وجو کم شدند، از صفحه خارج از محدوده جلوگیری شود.
    totalPages(total) {
      if (this.currentPage > total) this.currentPage = total;
    },
    selected(newValue) {
      this.localSelected = newValue;
      this.$emit("selectedItems", newValue);

      this.abrSelected = Array.isArray(newValue) ? [...newValue] : [newValue];
      if (Array.isArray(this.model)) {
        this.model.abrSelected = this.abrSelected;
      }
    },
    localSelected(newValue) {
      this.abrSelected = Array.isArray(newValue) ? [...newValue] : [newValue];
      if (Array.isArray(this.model)) {
        this.model.abrSelected = this.abrSelected;
      }
      this.$emit("update:selected", newValue);
      // model یک Array است؛ انتشار آن به شکل Object با spread می‌تواند
      // در والد (در صورت استفاده از .sync) نوع مدل را خراب کند.
      // برای فرم‌های دیگر قرارداد قدیمی update:model بدون تغییر باقی می‌ماند.
      if (!this.isPayorderCrSelectForm) {
        this.$emit("update:model", {
          ...this.model,
          abrSelected: this.abrSelected,
        });
      }
    },
  },
  created() {
    this.$eventBus.$off(`${this.def.id}-onSubmit`);
    this.$eventBus.$on(`${this.def.id}-onSubmit`, this.pushToModel);
  },

  async mounted() {
    this.$watch(
      "search",
      (nv) => {
        this.Model = this.model;
        const pass = [undefined, "", "Invalid date"];
        Object.keys(nv).forEach((key) => {
          if (pass.includes(this.search[key])) return;
          const targetProp = this.def.searchProps.find(
            (sp) => sp.name === key,
          )?.targetProp;
          let condition = this.def.searchProps.find(
            (sp) => sp.name === key,
          )?.conditions;
          if (condition) {
            this.filterModel(key, condition[0].condition, targetProp);
          }
        });
      },
      { deep: true },
    );
    this.def.eventHandlers &&
      this.$processEvent(this.def.eventHandlers, this.def.id);
    this.$nextTick(() => this.$eventBus.$emit(`${this.def.id}-onLoad`));
    this.headers = this.def.properties
      .filter((p) => p.show === undefined || p.show)
      .map((p, i) => ({
        def: p,
        [this.def.showExpand ? "show" : null]: i < 8,
        text: this.$t(p),
        value: p.name,
        filterable: p.origin?.name === this.def.filterField?.name,
        suffixLabel: this.$t(p.suffixLabel),
      }));
    this.isDefaultField = this.def?.properties.find(
      (p) =>
        this.def?.defaultField?.name &&
        p.origin?.name === this.def?.defaultField?.name,
    );
    this.headers.unshift({ show: true, text: "ردیف", value: "number" });
    this.headers.push({ show: true, text: "", value: "actions" });

    // console.log('this.headers :>> ', this.headers);

    this.$watch(
      "searchModel.result",
      (nv) => {
        if (
          Object.values(this.searchModel).length > 0 &&
          (Object.hasOwn(
            this.searchModel.basicSearch.query,
            "BasicSearchInput",
          ) ||
            Object.hasOwn(this.searchModel.advancedSearch, "query"))
        ) {
          const resultObjects = this.searchModel.result.filter(
            (item) => typeof item === "object",
          );
          this.Model = resultObjects;
        }
      },
      { deep: true },
    );

    this.$watch(
      "model",
      async (nv, ov) => {
        if (nv) {
          this.Model = nv;
          nv.forEach((m, index) =>
            Object.assign(m, { clientID: index, Deleted: m.Deleted ?? false }),
          );
          this.$nextTick(() => {
            if (ov && nv) {
              const hasChange = this.isModelDirty(nv);
              if (hasChange && this.def?.panel?.relationPath) {
                this.$eventBus.$emit(
                  `girdModelIsDirty`,
                  this.model,
                  this.def.panel.relationPath,
                );
              }
            }
            if (this.hasOnModelChangedEvent) {
              this.$eventBus.$emit(`${this.def.id}-onModelChanged`);
            }
          });
        }
      },
      { immediate: true, deep: true },
    );
    this.$watch(
      "model",
      () => {
        if (this.def.searchProps || this.def.searchConfig) return;
        if (this.$attrs.immediateChecker !== undefined) return;
        let p = this.$parent;
        while (p) {
          if (
            p.def &&
            (p.def.expandable || p.def.kind === "TFormSection") &&
            typeof p.onExpanded === "function"
          ) {
            p.onExpanded(this.model.filter((l) => !l.Deleted).length > 0);
            break;
          }
          p = p.$parent;
        }
      },
      {
        immediate: this.$attrs.immediateChecker === false ? false : true,
        deep: true,
      },
    );
    /// immediateChecker comes from riskPanel to pass watcher for cover Grids
  },
  methods: {
    // فقط اکشن «ایجاد/افزودن» در فرم موردنظر تأیید می‌خواهد.
    // این handler در فاز capture اجرا می‌شود؛ لذا API هنوز فراخوانی نشده است.
    interceptCreateClick(event, action) {
      if (!this.isPayorderCrSelectForm || this.allowConfirmedClick) return;
      const label = String(action?.label || action?.name || action?.origin?.name || '');
      const translated = typeof this.$t === 'function' ? String(this.$t(action) || '') : '';
      if (!/(ایجاد|افزودن|ثبت|create|add|submit)/i.test(`${label} ${translated}`)) return;
      if (!this.selectedCount) return;

      const button = event.target?.closest?.('button');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      this.pendingCreateButton = button;
      this.createConfirmOpen = true;
    },
    cancelCreateConfirmation() {
      this.createConfirmOpen = false;
      this.pendingCreateButton = null;
    },
    confirmCreateAction() {
      const button = this.pendingCreateButton;
      this.createConfirmOpen = false;
      this.pendingCreateButton = null;
      if (!button || !button.isConnected) return;
      // فقط کلیک تاییدشده اجازه عبور از capture را دارد.
      this.allowConfirmedClick = true;
      try { button.click(); }
      finally { this.allowConfirmedClick = false; }
    },
    visibleCol(defCol) {
      const show = defCol.show === undefined || defCol.show;
      const visibleValue =
        defCol.def?.visible?.visibleExpr?.value?.bool == undefined ||
        defCol.def?.visible?.visibleExpr?.value?.bool;
      const visibileScript =
        defCol.def?.visible?.visibleExpr?.script?.script == undefined ||
        defCol.def?.visible?.visibleExpr?.script?.script;

      const visible = show && visibleValue && visibileScript;

      // console.groupCollapsed(`visibleCol => %c  ${defCol.text} `, `color: #6eb5ff`, ' ==> AbrGrid ');
      // console.log('defCol :>> ', defCol);
      // console.log('show :>> ', show);
      // console.log('visibleValue :>> ', visibleValue);
      // console.log('visibileScript :>> ', visibileScript);
      // console.log('visible :>> ', visible);
      // console.groupEnd();

      return visible;
    },
    exportData() {
      const listData = this.Model?.filter((item) => !item.Deleted) || [];
      const propnames = this.def.properties.map((prop) => prop.name);

      this.listData = listData.map((obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
          if (propnames.includes(key)) {
            newObj[key] = obj[key];
          }
        });
        return newObj;
      });

      const result = this.listData.map((obj) => {
        const updatedObj = {};
        Object.entries(obj).forEach(([key, value]) => {
          const defObj = this.def.properties.find(
            (def) => def.name === key.toString(),
          );
          updatedObj[this.$t(defObj)] = this.displayValue(defObj, value);
        });
        return updatedObj;
      });
      this.$set(this, "listData", result);
      excelParser().exportDataFromJSON(this.listData, null, null);
    },
    // دریافت نتیجه دکمه ایجاد: جلوگیری از مقایسه O(n*m) و تغییر آرایه ورودی
    pushToModel(result) {
      // سایر فرم‌ها: منطق اصلی قدیمی بدون تغییر.
      if (!this.isPayorderCrSelectForm) {
        if (Array.isArray(result)) {
          this.model.length !== 0 &&
            this.model.forEach((m) =>
              result.forEach(
                (r, i) => m.ID === r.ID && !m.Deleted && result.splice(i, 1),
              ),
            );
          this.model.push(...result);
          this.afterSubmit(...result);
        } else {
          this.model.push(result);
          this.afterSubmit(result);
        }
        return;
      }

      // فقط فرم اعتبار: الگوریتم بهینه مناسب رکوردهای حجیم.
      const incoming = Array.isArray(result)
        ? result
        : result != null ? [result] : [];
      if (!incoming.length) return;

      const existingIDs = new Set(
        this.model.filter(item => !item.Deleted && item.ID != null)
          .map(item => item.ID)
      );
      const newItems = [];

      for (const item of incoming) {
        if (!item) continue;
        if (item.ID != null) {
          if (existingIDs.has(item.ID)) continue;
          existingIDs.add(item.ID);
        }
        newItems.push(item);
      }
      if (!newItems.length) return;

      // حفظ منطق فیلد پیش‌فرض؛ آرگومان‌های حجیم به afterSubmit ارسال نمی‌شوند.
      if (this.isDefaultField) {
        const field = this.isDefaultField;
        const falseValue = this.$lookupValue(field.lookup, false);
        const trueValue = this.$lookupValue(field.lookup, true);
        this.model.forEach(item => { item[field.name] = falseValue; });
        newItems.forEach(item => { item[field.name] = falseValue; });
        newItems[0][field.name] = trueValue;
      }

      // push یکجا؛ رندر فقط 100 سطر صفحه فعلی را انجام می‌دهد.
      this.model.push(...newItems);
    },

    // Vuetify 2: تیک سرستون به طور عادی فقط آیتم‌های صفحه جاری را انتخاب می‌کند.
    // این handler همه رکوردهای بارگذاری‌شده و قابل نمایش در getModel را انتخاب می‌کند.
    handleSelectAll({ value }) {
      // در همه فرم‌های دیگر انتخاب پیش‌فرض Vuetify حفظ می‌شود.
      if (!this.isPayorderCrSelectForm) return;
      if (value) {
        this.localSelected = this.getModel.filter(item => !item.Deleted).slice();
        this.selectAllRecords = true;
      } else {
        this.localSelected = [];
        this.selectAllRecords = false;
      }
      // watcherِ localSelected مقدار model.abrSelected را برای AppButton تنظیم می‌کند.
    },

    setDefault(item, index) {
      let newModel = [...this.model];
      newModel.forEach((m, i) => {
        m[this.isDefaultField?.name] = this.$lookupValue(
          this.isDefaultField.lookup,
          i === index,
        );
      });
      this.$eventBus.$emit(
        "changeModelInGrid",
        newModel,
        this.def.panel.relationPath,
      );
    },
    afterSubmit(payload) {
      if (this.isDefaultField) {
        this.model.forEach((m) => {
          m[this.isDefaultField?.name] = this.$lookupValue(
            this.isDefaultField.lookup,
            false,
          );
        });
        payload[this.isDefaultField?.name] = this.$lookupValue(
          this.isDefaultField.lookup,
          true,
        );
      }
    },
    // async fetchLookups() {
    //   console.log(this.def.properties , "THIS IS PROPERTIES");
    //   const lookups =
    //     this.def.properties.filter(p => p.lookup).map(p => ({
    //       prop: p,
    //       lookup: p.lookup,
    //       values: new Set(this.model
    //           .filter(m => !m.Deleted)
    //           .map(row => row[p.name])
    //           .filter(v => v && (!this.$store.state.lookupCache[p.lookup.id] || !this.$store.state.lookupCache[p.lookup.id][v]))
    //       )
    //     }));
    //   if (lookups.length) {
    //     await Promise.all(lookups.map(async l => {
    //       console.log(l , l.values , '&&&&&&&&&&&&&&&&&&&&');
    //       l.values.size && await this.$abr.api.fetchLookupData(l.lookup, undefined, undefined, l.values.values());
    //       this.model.filter(l!m.Deleted).forEach((row, index) => {
    //         if (!this.cells[index])
    //           this.$set(this.cells, index, {})
    //         this.$set(this.cells[index], l.prop.name, this.$abr.api.resolveLookup(l.lookup, row[l.prop.name]))
    //       });
    //     }))
    //   }
    // },
    remove(item) {
      const deletedItem = JSON.parse(JSON.stringify(item));
      if (!item.ID) {
        this.model.splice(item.clientID, 1);
      } else {
        if (this?.$formMode === "fmEdit") {
          deletedItem.Deleted = true;
          this.$set(this.model, this.model.indexOf(item), deletedItem);
        } else {
          this.model.splice(item.clientID, 1);
          deletedItem.Deleted = true;
        }

        // this.$set(this.model, this.model.indexOf(item), deletedItem);
      }
      if (this.def.panel.relationPath) {
        this.$eventBus.$emit(
          "changeModelInGrid",
          this.model,
          this.def.panel.relationPath,
        );
      }
    },
    filterModel(searchProp, condition, key) {
      this.Model = this.Model.filter((p) =>
        Object.keys(p).some(
          (k) =>
            key === k &&
            this.checkCondition(p[k], this.search[searchProp], condition),
        ),
      );
    },
    checkCondition(value, search, condition) {
      switch (condition) {
        case "GT":
          return value > search;
        case "GTE":
          return value >= search;
        case "LT":
          return value < search;
        case "LTE":
          return value <= search;
        case "SW":
          return value.startsWith(search);
        case "EW":
          return value.endsWith(search);
        case "CNT":
          return value.includes(search);
        case "EQ":
          return value === search;
        case "NEQ":
          return value !== search;
        case "ISNULL":
          return value === null;
        case "NOTNULL":
          return value !== null;
        default:
          return false;
      }
    },
    getPortalId() {
      if (this.def.name === "SearchResult") {
        return this.def.id;
      }
      if (this.def?.panel?.section) return this.def?.panel?.section.id;
      const getParentPanelID = (def) => {
        if (def === undefined) return;
        if (def.panel && def.panel.expandable) {
          return def.panel.id;
        }
        return getParentPanelID(def.parentPanel);
      };
      return getParentPanelID(this.def);
    },
    checkPageType() {
      if (this.def.name === "SearchResult") {
        return `${this.getPortalId()}.gridactions`;
      }
      return `${this.getPortalId()}.leftSection`;
    },
    isModelDirty(targetModel) {
      let hasChange = false;
      if (Array.isArray(targetModel)) {
        targetModel.forEach(async (modelItem) => {
          if (modelItem?.__proxy__?.dirty) {
            const dirty = new Map(Object.entries(modelItem.__proxy__.dirty));
            dirty.forEach((value, key) => {
              if (value) hasChange = value;
            });
          }
        });
      }
      return hasChange;
    },
  },
};
</script>
<style scoped>
/* Grid Container */
.grid_table {
  width: 100%;
  background: var(--abr-BG1);
  border: 1px solid rgba(var(--abr-p1-rgb), 0.08);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

/* Table Wrapper - Responsive Fix */
::v-deep(.v-data-table__wrapper) {
  width: 100% !important;
  max-width: 100% !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  scrollbar-width: thin;
}

/* ====================== HEADER ====================== */
::v-deep(.grid_table .v-data-table-header),
::v-deep(.grid_table thead) {
  position: sticky;
  top: 0;
  z-index: 3;
  background: rgba(var(--abr-p1-rgb), 0.22);
  backdrop-filter: blur(10px);
}

::v-deep(.grid_table thead th) {
  height: 54px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  text-align: center !important;
  padding: 0 6px !important;
  white-space: nowrap;
  color: var(--abr-G1) !important;
  background: transparent !important;
}

::v-deep(.grid_table thead th:hover) {
  background: rgba(var(--abr-p1-rgb), 0.12);
}

/* ====================== BODY ====================== */
::v-deep(.grid_table tbody td) {
  text-align: center !important;
  vertical-align: middle !important;
  font-size: 12px;
  padding: 7px 5px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

/* فقط محتوای دیتای سلول */
.grid-cell-content {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;

  white-space: normal !important;
  word-break: normal !important;
  overflow-wrap: anywhere !important;

  line-height: 1.6;
}

/* Zebra + Hover */
::v-deep(.grid_table tbody tr:nth-child(even)) {
  background: rgba(var(--abr-bg2-rgb), 0.35);
}

::v-deep(.grid_table tbody tr:hover) {
  background: rgba(var(--abr-p1-rgb), 0.06) !important;
}
/* ====================== ROW ACTIONS ====================== */

.actions {
  display: flex;
  align-items: right;
  justify-content: right;
  gap: 6px;
  min-height: 36px;
}

/* Base Row Action */
::v-deep(.rowAction) {
  opacity: 0;
  visibility: hidden;
  transform: translateY(4px) scale(0.9);

  transition: all 0.2s ease;

  min-width: 30px !important;
  width: 30px;
  height: 30px;

  padding: 0 !important;
  margin: 0 2px;

  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: var(--abr-g3, #9e9e9e) !important;
  border-radius: 50%;
}

/* Show when row is hovered */
::v-deep(.grid_table tbody tr:hover .rowAction) {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

/* Hover on single action */
::v-deep(.rowAction:hover) {
  color: var(--abr-p1, #0099a8) !important;
  transform: scale(1.1);
  z-index: 5; /* جلوگیری از هم‌پوشانی */
  box-shadow: 0 3px 8px rgba(var(--abr-p1-rgb), 0.25);
}

/* Always visible actions */
::v-deep(.rowAction.always-visible) {
  opacity: 1 !important;
  visibility: visible !important;
  transform: none !important;
}

/* ====================== Responsive - فقط برای عرض جدول در صفحه کوچک ====================== */

@media (max-width: 1366px) {
  ::v-deep(.grid_table table) {
    min-width: 1150px; /* حداقل عرض مناسب برای مانیتور کوچک */
  }
}

@media (max-width: 1024px) {
  ::v-deep(.grid_table table) {
    min-width: 1000px;
  }

  .actions {
    gap: 4px;
    padding: 0 8px 0 6px;
  }
}

/* ====================== Scrollbar ====================== */
::v-deep(.v-data-table__wrapper::-webkit-scrollbar) {
  width: 8px;
  height: 8px;
}

::v-deep(.v-data-table__wrapper::-webkit-scrollbar-track) {
  background: var(--abr-bg2, #f5f6fa);
}

::v-deep(.v-data-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(var(--abr-p1-rgb), 0.25);
  border-radius: 10px;
}

::v-deep(.v-data-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(var(--abr-p1-rgb), 0.45);
}

/* Firefox */
::v-deep(.v-data-table__wrapper) {
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--abr-p1-rgb), 0.25) var(--abr-bg2, #f5f6fa);
}
/* صفحه‌بندی ویژه frmSearchPayorderCrSelect */
.payorder-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: var(--abr-BG1, #fff);
  border-top: 1px solid rgba(var(--abr-p1-rgb), 0.12);
  color: var(--abr-G1, #334155);
  font-size: 13px;
}
.payorder-page-info, .payorder-page-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.payorder-page-info strong { font-weight: 700; }
.payorder-page-selection {
  padding: 5px 10px;
  border-radius: 16px;
  background: rgba(var(--abr-p1-rgb), 0.08);
  color: var(--abr-p1, #1976d2);
  font-weight: 600;
}
.payorder-page-caption { white-space: nowrap; }
.payorder-page-buttons { margin: 0; }
.payorder-page-buttons ::v-deep(.v-pagination__item),
.payorder-page-buttons ::v-deep(.v-pagination__navigation) {
  box-shadow: none;
  border: 1px solid rgba(var(--abr-p1-rgb), 0.15);
}
@media (max-width: 700px) {
  .payorder-pagination { justify-content: center; padding: 12px 8px; }
  .payorder-page-info, .payorder-page-controls { justify-content: center; }
}
</style>

<style scoped>
.payorder-action-wrapper { display: inline-flex; }
.payorder-confirm-card { border-radius: 14px; }
.payorder-confirm-title { font-weight: 700; font-size: 17px; }
.payorder-confirm-text { line-height: 2; font-size: 14px; }
</style>
